import React from 'react';
import { shape, bool, func, string } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { operations } from 'state/ducks/map';
import LoadingIndicator from 'components/LoadingIndicator';
import List from '../List';
import ListItem from '../ListItem';
import LocationsListItem from '../LocationsListItem';
import EmptyPanelState from '../EmptyPanelState';

const AlertsQuery = gql`
  query Alerts {
    locations {
      id
      name
      trackingDevice {
        id
        name
        status
        batteryVoltage
        temperature
        reportInterval
        lastUpdate
        numberOfHitsToday
        hitsToday
      }
    }
  }
`;

function isStatusProblematic(status) {
  if (status === 'warning' || status === 'disconnected') {
    return true;
  }

  return false;
}

export function Alerts({ data, selectEntity, enterEntity, leaveEntity, currentHover }) {
  if (data.loading) {
    return <LoadingIndicator />;
  }

  const items = data.locations.filter(({ trackingDevice }) =>
    isStatusProblematic(trackingDevice.status)
  );

  // We don't have any alerts yet
  if (!items || items.length === 0) {
    return <EmptyPanelState panelType={'alert'} hideIcon />;
  }

  return (
    <List>
      {items.map(location => {
        const { id, trackingDevice } = location;
        const status = trackingDevice.status;
        const isActive = currentHover && currentHover.id === id;
        return (
          <ListItem
            id={id}
            key={id}
            status={status}
            isActive={isActive}
            onClick={() => selectEntity({ id, type: 'location' })}
            onMouseOver={() => enterEntity({ id, type: 'location' })}
            onMouseOut={() => leaveEntity({ id, type: 'location' })}
            contentType="location"
          >
            <LocationsListItem location={location} />
          </ListItem>
        );
      })}
    </List>
  );
}

Alerts.propTypes = {
  data: shape({
    loading: bool.isRequired,
    location: shape({}),
  }).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

const mapStateToProps = ({ map }, ownProps) => ({
  currentHover: map.currentHover,
  ...ownProps,
});

const ConnectedAlertsWithData = compose(
  connect(mapStateToProps, operations),
  graphql(AlertsQuery, {
    options: ({ params }) => ({
      variables: {
        id: params.id,
      },
    }),
  })
)(Alerts);

export default ConnectedAlertsWithData;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/Alerts/index.js